<template>
  <div>
    <tabs>
      <tab name="Inbox" :selected="true">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 mt-2">
            <DemoLoader inbox="inbox"></DemoLoader>
          </div>
        </div>
      </tab>
      <tab name="Approved">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 mt-2">
            <DemoLoader inbox="approved"></DemoLoader>
          </div>
        </div>
      </tab>
      <tab name="Declined">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 mt-2">
            <DemoLoader inbox="declined"></DemoLoader>
          </div>
        </div>
      </tab>
    
    </tabs>
  </div>
</template>

<script>
import Tabs from "../components/Tabs";
import Tab from "../components/Tab";
import DemoLoader from "../components/DemoLoader";
export default {
  name: "home",
  components: {
    Tabs,
    Tab,
    DemoLoader,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>